var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircleCheckFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0508 1C14.8833 1 18.8008 4.91751 18.8008 9.75C18.8008 14.5825 14.8833 18.5 10.0508 18.5C5.21829 18.5 1.30078 14.5825 1.30078 9.75C1.30078 4.91751 5.21829 1 10.0508 1ZM14.1465 7.42383C13.8284 7.15893 13.356 7.20171 13.0908 7.51953L9.44922 11.8887L7.53027 9.96973C7.23738 9.67683 6.76262 9.67683 6.46973 9.96973C6.17683 10.2626 6.17683 10.7374 6.46973 11.0303L8.96973 13.5303C9.11873 13.6793 9.32368 13.7586 9.53418 13.749C9.74452 13.7394 9.94132 13.6422 10.0762 13.4805L14.2432 8.48047C14.5083 8.16226 14.4647 7.689 14.1465 7.42383Z",
    fill: "#6130B5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheckFilled);
export default __webpack_public_path__ + "static/media/circle-check-filled.26ef0881d1a16261771afc86cd9bfdaf.svg";
export { ForwardRef as ReactComponent };